(() => {
  // Mobile header: the search row only shows at the top of the page; anywhere below it stays collapsed.
  const header = document.querySelector('.m27-store-header');
  const search = header?.querySelector('.m27-search');
  const brand = header?.querySelector('.m27-wordmark');
  if (!header || !search || !brand) return;

  // Hide past hideAfter, show again only above showBefore; the gap stops flicker at the boundary.
  const hideAfter = 96;
  const showBefore = 48;
  let ticking = false;

  // Only collapse when search sits on its own row (the mobile layout), never on desktop.
  const searchOnOwnRow = () => search.offsetTop > brand.offsetTop + brand.offsetHeight / 2;

  const update = () => {
    ticking = false;
    const y = Math.max(0, window.scrollY);
    if (search.contains(document.activeElement) || !searchOnOwnRow() || y < showBefore) {
      header.classList.remove('is-search-hidden');
    } else if (y > hideAfter) {
      header.classList.add('is-search-hidden');
    }
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }, { passive: true });
  window.addEventListener('resize', update);
  search.addEventListener('focusin', () => header.classList.remove('is-search-hidden'));
  update();
})();
